export default function IconSelectDropDown({ id }: { id?: string }) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="8"
      viewBox="0 0 16 8"
    >
      <path
        id="Path_647"
        data-name="Path 647"
        d="M0,0,8,8l8-8Z"
        transform="translate(0 0)"
      />
    </svg>
  );
}
